import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '~/api-client';
import { useHandleSearchResponse } from '../search-windows/use-handle-search-response';
import { useUnitStatusSearchResultsPaginationContext } from './unit-status-search-results-pagination-provider';
import { useUnitStatusSearchSortContext } from './unit-status-search-sort-provider';
import { CadSearchsaveResource } from '@mark43/cad-api';

export function useExecuteSavedUnitStatusSearchQuery(tabId: number, savedSearchId?: number) {
    const pagination = useUnitStatusSearchResultsPaginationContext();
    const sort = useUnitStatusSearchSortContext();
    const apiClient = useApiClient();
    const handleSearchResponse = useHandleSearchResponse(pagination);
    return useQuery(
        [
            'saved-event-search',
            tabId,
            savedSearchId,
            pagination.itemOffset,
            pagination.itemsPerPage,
            sort.sortByValue.value,
            sort.directionValue.value,
        ] as const,
        ({ queryKey }) => {
            return apiClient
                .request<CadSearchsaveResource.ExecuteSavedUnitStatusSearch>({
                    method: 'POST',
                    url: 'cad_search/save/unit_status/execute',
                    data: {
                        // query only enabled if savedSearchId exists
                        savedSearchId: queryKey[2]!,
                        showNewResults: false,
                        from: queryKey[3],
                        size: queryKey[4],
                        sortKey: queryKey[5],
                        sortType: queryKey[6],
                    },
                })
                .then((resp) => {
                    const unitStatusSearchResponse = resp.data.data;
                    handleSearchResponse(unitStatusSearchResponse?.totalCount, queryKey[3]);
                    return unitStatusSearchResponse;
                });
        },
        {
            enabled: !!savedSearchId,
        }
    );
}
